import { useState } from 'react';
import cn from 'classnames';
import styles from './Creator.module.sass';
import ModalProduct from '../../../components/ModalProduct';
import SendMailModal from './sendMailModal';
import Actions from '../../../components/Actions';
import { useUser } from '../../../context';
import { useHistory } from 'react-router';
import { UseApi } from '../../../hooks/use-api';
import { DeleteBrand } from '../../../Services/lib/brand';
import Modal from '../../../components/Modal';
import Confirm from '../../../components/Confirm';
import { UseDisclosure } from '../../../hooks/use-disclosure';
import { ToastEmitter } from '../../../Services/assets/toast-emitter';
import { RollBack } from '../../../Services/lib/admin';
import brand_text from '../../../i11/brand';

const Creator = ({ className, item, fetch }) => {
  const { setbrand, locale } = useUser();
  const [{ isLoading }, delete_] = UseApi({
    service: DeleteBrand,
  });
  const {
    isOpen: confirmV,
    onClose: confirmC,
    onOpen: confirmO,
  } = UseDisclosure();
  const history = useHistory();
  const [isOpen, setOpen] = useState(false);
  const [visibleModalProduct, setVisibleModalProduct] = useState(false);
  const [is_showing_modal, setIsShowingModal] = useState(false);
  const actions = [
    {
      title: brand_text[locale].add_o,
      icon: 'profile-circle',
      action: () => {
        setOpen(!isOpen);
        setIsShowingModal(!is_showing_modal);
      },
    },
    {
      isLoading,
      title: brand_text[locale].delete_b,
      icon: 'trash',
      action: confirmO,
    },
  ];

  const onConfirm = async () => {
    const res = await delete_(item._id);
    if (res) {
      ToastEmitter({
        msg: 'Brand deleted',
        type: 'success',
      });
      fetch();
    }
  };

  return (
    <>
      <div className={cn(styles.creator, className)}>
        <div className={styles.head}>
          <div className={styles.user}>
            <div className={styles.avatar}>
              <img src={item.image} alt='Avatar' />
            </div>
            <div className={styles.details}>
              <div className={styles.line}>
                <div className={styles.man}>{item.brandname}</div>
              </div>
            </div>
          </div>
          <div className={styles.btns}>
            {item.dummyBackUp && <ResetButton id={item._id} />}
            <button
              onClick={() => {
                setbrand(item);
                history.push('/');
              }}
              className='button button-small button-stroke'
            >
              {brand_text[locale].view}
            </button>
            <Actions
              className={styles.actions}
              classActionsHead={styles.actionsHead}
              items={actions}
            />
          </div>
        </div>
      </div>

      <ModalProduct
        visible={visibleModalProduct}
        onClose={() => setVisibleModalProduct(false)}
      />

      {is_showing_modal && (
        <SendMailModal
          data={item}
          visible={is_showing_modal}
          onClose={() => {
            setIsShowingModal(false);
          }}
        />
      )}
      <Modal visible={confirmV} onClose={confirmC}>
        <Confirm
          title={brand_text[locale].confirm_text}
          onCancel={confirmC}
          onConfirm={onConfirm}
          isLoading={isLoading}
        />
      </Modal>
    </>
  );
};

const ResetButton = ({ id }) => {
  const { isOpen, onClose, onOpen: onOpen_ } = UseDisclosure();

  const [{ isLoading }, reset] = UseApi({
    service: RollBack,
    successMsg:
      'Successfully rolled back. You need to reload entire application.',
  });

  const reset_ = async () => {
    const res = await reset(id);
    if (res) {
      onClose();
    }
  };
  return (
    <>
      <button onClick={onOpen_} className='button-small button-stroke'>
        Reset
      </button>
      <Modal visible={isOpen} onClose={onClose}>
        <Confirm
          note='Roll back to snapshot'
          isLoading={isLoading}
          onConfirm={reset_}
          onCancel={onClose}
        />
      </Modal>
    </>
  );
};

export default Creator;
